import U, { deserialize as D } from "@fond-of/api-client";
const O = async (s, a, t, e = {}) => await s.post(`customers/${a}/addresses`, {
  ...e,
  json: {
    data: {
      type: "addresses",
      attributes: t
    }
  }
}).json(), q = async (s, a, t, e, r = {}) => await s.patch(`customers/${a}/addresses/${t}`, {
  ...r,
  json: {
    data: {
      type: "addresses",
      attributes: e
    }
  }
}).json();
/*! js-cookie v3.0.5 | MIT */
function C(s) {
  for (var a = 1; a < arguments.length; a++) {
    var t = arguments[a];
    for (var e in t)
      s[e] = t[e];
  }
  return s;
}
var x = {
  read: function(s) {
    return s[0] === '"' && (s = s.slice(1, -1)), s.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(s) {
    return encodeURIComponent(s).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function P(s, a) {
  function t(r, o, c) {
    if (!(typeof document > "u")) {
      c = C({}, a, c), typeof c.expires == "number" && (c.expires = new Date(Date.now() + c.expires * 864e5)), c.expires && (c.expires = c.expires.toUTCString()), r = encodeURIComponent(r).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var n = "";
      for (var u in c)
        c[u] && (n += "; " + u, c[u] !== !0 && (n += "=" + c[u].split(";")[0]));
      return document.cookie = r + "=" + s.write(o, r) + n;
    }
  }
  function e(r) {
    if (!(typeof document > "u" || arguments.length && !r)) {
      for (var o = document.cookie ? document.cookie.split("; ") : [], c = {}, n = 0; n < o.length; n++) {
        var u = o[n].split("="), m = u.slice(1).join("=");
        try {
          var g = decodeURIComponent(u[0]);
          if (c[g] = s.read(m, g), r === g)
            break;
        } catch {
        }
      }
      return r ? c[r] : c;
    }
  }
  return Object.create(
    {
      set: t,
      get: e,
      remove: function(r, o) {
        t(
          r,
          "",
          C({}, o, {
            expires: -1
          })
        );
      },
      withAttributes: function(r) {
        return P(this.converter, C({}, this.attributes, r));
      },
      withConverter: function(r) {
        return P(C({}, this.converter, r), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(a) },
      converter: { value: Object.freeze(s) }
    }
  );
}
var I = P(x, { path: "/" });
const p = () => typeof window < "u" && typeof window.document < "u", z = () => !p(), G = () => p() && window.location.host.startsWith("beta"), E = () => I.get("IS_CANARY") === "true", T = () => I.get("fondof_internal") === "true", F = () => p() && window.location.host.includes("stage."), L = () => p() && (window.location.host.includes("dev.") || window.location.host.includes("localhost")), N = () => p() && window.location.host.includes("www."), j = {
  isBrowser: p(),
  isSSR: z(),
  isBeta: G(),
  isCanary: E(),
  isInternal: T(),
  isStage: F(),
  isDev: L(),
  isProd: N()
}, H = (s) => {
  if (s)
    return new URLSearchParams(s);
}, K = (...s) => s.reduce(
  (a, t) => {
    const e = H(t);
    return e != null && e.toString() && a.toString() ? new URLSearchParams(
      `${e.toString()}&${a.toString()}`
    ) : e != null && e.toString() ? e : a;
  },
  new URLSearchParams()
), d = (s, ...a) => {
  const t = K(...a), e = t == null ? void 0 : t.get("include");
  return t == null || t.set(
    "include",
    [s, e].filter((r) => !!r).join(",")
  ), t;
}, $ = (s, a, t, e = {}) => {
  var r;
  return s.post(`guest-carts/${a}/cart-codes`, {
    uuid: !0,
    ...e,
    json: {
      data: {
        type: "cart-codes",
        attributes: t
      }
    },
    hooks: {
      ...e.hooks,
      afterResponse: [
        ...((r = e.hooks) == null ? void 0 : r.afterResponse) || [],
        // Handle 422 as a successful request as it will only be returned if the voucher code is incorrect.
        // So we don't need to track the response.
        (o, c, n) => n.status !== 422 ? n : new Response(null, { status: 200 })
      ]
    }
  });
}, W = (s, a, t, e = {}) => s.delete(`guest-carts/${a}/cart-codes/${t}`, {
  uuid: !0,
  ...e
}), i = "gift-cards,concrete-products,concrete-product-prices,concrete-product-image-sets,promotional-items", l = ({
  guestCartItems: s,
  items: a,
  ...t
}) => ({
  ...t,
  cartItems: s || a || []
}), f = (s) => async (a) => {
  if (!a.headers.has("Authorization"))
    return await s();
}, _ = async (s, a, t = {}) => l(
  await s.post("carts", {
    uuid: !1,
    auth: !0,
    ...t,
    searchParams: d(
      "items",
      {
        include: i
      },
      t.searchParams
    ),
    json: {
      data: {
        type: "carts",
        attributes: {
          priceMode: "GROSS_MODE",
          currency: "EUR",
          name: "UNKNOWN",
          store: a
        }
      }
    }
  }).json()
), M = (s, a, t, e = {}) => s.post(`carts/${a}/items`, {
  uuid: !1,
  auth: !0,
  ...e,
  searchParams: d(
    "items",
    {
      include: i
    },
    e.searchParams
  ),
  json: {
    data: {
      type: "items",
      attributes: t
    }
  }
}), Y = (s, a, t = {}) => s.post("guest-cart-items", {
  auth: !1,
  uuid: !0,
  ...t,
  searchParams: d(
    "guest-cart-items",
    {
      include: i
    },
    t.searchParams
  ),
  json: {
    data: {
      type: "guest-cart-items",
      attributes: a
    }
  }
}), b = async (s, a, t, e = {}) => l(
  await M(s, a, t, {
    ...e,
    hooks: {
      beforeRequest: [
        f(
          () => Y(s, t, e)
        )
      ]
    }
  }).json()
), J = (s, a, t = {}) => s.get(`carts/${a}/`, {
  auth: !0,
  uuid: !1,
  ...t,
  searchParams: d(
    "items",
    {
      include: i
    },
    t.searchParams
  )
}), A = (s, a, t = {}) => s.get(`guest-carts/${a}`, {
  auth: !1,
  uuid: !0,
  ...t,
  searchParams: d(
    "guest-cart-items",
    {
      include: i
    },
    t.searchParams
  )
}), k = async (s, a, t = {}) => l(
  await J(s, a, {
    ...t,
    searchParams: d(
      "items",
      {
        include: i
      },
      t.searchParams
    ),
    hooks: {
      beforeRequest: [
        f(
          () => A(s, a, t)
        )
      ]
    }
  }).json()
), Q = (s, a, t, e = {}) => s.patch(`carts/${a}/items/${t.sku}`, {
  uuid: !1,
  auth: !0,
  ...e,
  searchParams: d(
    "items",
    {
      include: i
    },
    e.searchParams
  ),
  json: {
    data: {
      type: "items",
      attributes: t
    }
  }
}), V = (s, a, t, e = {}) => s.patch(`guest-carts/${a}/guest-cart-items/${t.sku}`, {
  auth: !1,
  uuid: !0,
  ...e,
  searchParams: d(
    "guest-cart-items",
    {
      include: i
    },
    e.searchParams
  ),
  json: {
    data: {
      type: "guest-cart-items",
      attributes: t
    }
  }
}), X = async (s, a, t, e = {}) => l(
  await Q(s, a, t, {
    ...e,
    hooks: {
      beforeRequest: [
        f(
          () => V(s, a, t, e)
        )
      ]
    }
  }).json()
), Z = (s, a, t, e = {}) => s.delete(`carts/${a}/items/${t}`, {
  uuid: !1,
  auth: !0,
  ...e
}), tt = (s, a, t, e = {}) => s.delete(`guest-carts/${a}/guest-cart-items/${t}`, {
  auth: !1,
  uuid: !0,
  ...e
}), et = (s, a, t, e = {}) => Z(s, a, t, {
  ...e,
  hooks: {
    beforeRequest: [
      f(
        () => tt(s, a, t, e)
      )
    ]
  }
}), st = async (s, a, t = {}) => (await s.get(`customers/${a}/carts`, {
  uuid: !1,
  auth: !0,
  ...t,
  searchParams: d(
    "items",
    {
      include: i
    },
    t.searchParams
  )
}).json()).map((e) => l(e)), R = async (s, a, t, e) => {
  let [r] = await st(s, t, e);
  return r || (r = await _(s, a, e)), r;
}, at = async (s, a, t, e, r = {}) => {
  var n, u, m, g;
  const o = t == null ? void 0 : t.id, c = (t == null ? void 0 : t.type) === "guestCarts";
  if (c && o && e && !j.isBeta) {
    let h = await R(
      s,
      a,
      e,
      r
    );
    const y = l(
      await A(
        s,
        o,
        r
      ).json()
    ), S = ((u = (n = y.giftCards) == null ? void 0 : n[0]) == null ? void 0 : u.code) || ((g = (m = y.discounts) == null ? void 0 : m[0]) == null ? void 0 : g.code);
    for (const w of y.cartItems)
      try {
        h = await b(
          s,
          h.id,
          {
            quantity: w.quantity,
            sku: w.sku
          },
          r
        );
      } catch (B) {
        console.error(B);
      }
    if (S)
      try {
        await $(
          s,
          h.id,
          {
            code: S
          },
          r
        ), h = await k(s, h.id, r);
      } catch (w) {
        console.error(w);
      }
    return h;
  }
  if (o)
    return await k(s, o, r);
  if (!c && !o && e)
    return await R(s, a, e, r);
}, rt = ({
  items: s,
  ...a
}) => ({
  ...a,
  cartItems: s || []
}), ot = async (s, a, t = {}) => await s.post("checkout", {
  uuid: !0,
  auth: !0,
  ...t,
  searchParams: j.isBeta || j.isDev ? d("orders", t.searchParams) : t.searchParams,
  json: {
    data: {
      type: "checkout",
      attributes: a
    }
  }
}).json(), ct = async (s, a, t = {}) => {
  const {
    carts: e = [],
    guestCarts: r = [],
    ...o
  } = await s.post("checkout-data", {
    uuid: !0,
    auth: !0,
    ...t,
    searchParams: d(
      "payment-methods,carts,guest-carts,items,concrete-products,concrete-product-prices,concrete-product-image-sets,gift-cards,promotional-items",
      t.searchParams
    ),
    json: {
      data: {
        type: "checkout-data",
        attributes: a
      }
    }
  }).json();
  return {
    ...o,
    carts: [...e, ...r].map(rt)
  };
}, nt = (s, a, t = {}) => s.post("customer-complaints", {
  json: {
    data: {
      type: "customer-complaints",
      attributes: a
    }
  },
  ...t
}).json(), ut = async (s, a = {}) => {
  const t = await s.get("customers", {
    throwHttpErrors: !1,
    searchParams: {
      include: "addresses"
    },
    ...a
  }).json();
  return t == null ? void 0 : t[0];
}, dt = async (s, a, t = {}) => {
  var e;
  return await s.post("customer-registration", {
    throwHttpErrors: !1,
    ...t,
    json: {
      data: {
        type: "customer-registration",
        attributes: a
      }
    },
    hooks: {
      afterResponse: [
        async (r, o, c) => {
          var m;
          if (c.status !== 422)
            return c;
          const n = await c.json(), u = (m = n == null ? void 0 : n.errors) == null ? void 0 : m[0];
          return (u == null ? void 0 : u.code) === "3" ? new Response(null, { status: 200 }) : c;
        },
        ...((e = t.hooks) == null ? void 0 : e.afterResponse) || []
      ]
    }
  });
}, it = async (s, a, t = {}) => await s.post("customer-confirmation", {
  ...t,
  json: {
    data: {
      type: "customer-confirmation",
      attributes: a
    }
  }
}), mt = async (s, a, t = {}) => await s.post("customer-forgotten-password", {
  ...t,
  json: {
    data: {
      type: "customer-forgotten-password",
      attributes: a
    }
  }
}), gt = async (s, a, t = {}) => await s.patch(
  `customer-restore-password/${a.restorePasswordKey}`,
  {
    ...t,
    json: {
      data: {
        type: "customer-restore-password",
        id: a.restorePasswordKey,
        attributes: a
      }
    }
  }
), ht = async (s, a, t = {}) => await s.post("customer-password-updated", {
  ...t,
  json: {
    data: {
      type: "customer-password-updated",
      attributes: a
    }
  }
}).json(), pt = async (s, a, t = {}) => await s.post("access-tokens", {
  uuid: !0,
  ...t,
  json: {
    data: {
      type: "access-tokens",
      attributes: a
    }
  }
}).json(), lt = async (s, a, t = {}) => await s.post("customers", {
  uuid: !0,
  ...t,
  json: {
    data: {
      type: "customers",
      attributes: {
        ...a,
        confirmPassword: a.password,
        acceptedTerms: !0
      }
    }
  }
}).json(), wt = async (s, a, t = {}) => await s.get(`orders/${a}`, t).json(), Ct = async (s, a = {}) => (await s.get("orders", a).json()).map((e) => ({
  ...e,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  items: e.items.map((r) => ({
    ...r,
    state: r.state.name
  }))
})), v = (s) => {
  var e;
  const a = (e = s.data) == null ? void 0 : e[0].attributes.abstractProducts, [{ abstractProducts: t }] = D(s);
  return t.map(
    (r) => ({
      ...r,
      ...a.find(
        (o) => o.abstractSku === r.sku
      ) || {}
    })
  );
}, ft = async (s, a = {}) => {
  const t = await s.get("catalog-search", {
    ...a,
    searchParams: d(
      "abstract-products",
      a.searchParams
    ),
    deserialize: !1
  }).json();
  return {
    ...t.data[0],
    attributes: {
      ...t.data[0].attributes,
      // @ts-ignore
      abstractProducts: v(t)
    }
  };
}, yt = async (s, a, t = {}) => {
  const e = a.map((o) => ["sku[]", `Abstract-${o}`]), r = await s.get("catalog-search", {
    ...t,
    searchParams: d(
      "abstract-products",
      t.searchParams,
      e
    ),
    deserialize: !1
  }).json();
  return v(r);
}, Pt = async (s, a, t = {}) => {
  const e = await s.get("catalog-search", {
    ...t,
    searchParams: d(
      "abstract-products",
      {
        category: a
      },
      t.searchParams
    ),
    deserialize: !1
  }).json();
  return v(e);
}, jt = (s, a, t = {}) => s.get(`abstract-products/${a}`, t).json(), kt = async (s, a, t = {}) => await s.get("catalog-search-suggestions", {
  ...t,
  searchParams: {
    q: a
  },
  deserialize: !0
}).json(), St = {
  new: (s, a = {}) => {
    const t = U.new({
      deserialize: !0,
      ...a,
      prefixUrl: s
    });
    return t.getLoggedInCustomer = (e = {}) => ut(t, e), t.registerCustomer = (e, r = {}) => dt(t, e, r), t.confirmCustomerRegistration = (e, r = {}) => it(t, e, r), t.getCartById = (e, r = {}) => k(t, e, r), t.updateCartItem = (e, r, o = {}) => X(t, e, r, o), t.removeCartItem = (e, r, o = {}) => et(t, e, r, o), t.addCartCode = (e, r, o = {}) => $(t, e, r, o), t.removeCartCode = (e, r, o = {}) => W(t, e, r, o), t.getProductsBySkus = (e, r = {}) => yt(t, e, r), t.getProducts = (e = {}) => ft(t, e), t.getProductsByCategory = (e, r = {}) => Pt(t, e, r), t.getAbstractProduct = (e, r = {}) => jt(t, e, r), t.getCatalogSearchSuggestions = (e, r = {}) => kt(t, e, r), t.getOrder = (e, r = {}) => wt(t, e, r), t.getOrders = (e = {}) => Ct(t, e), t.placeOrder = (e, r = {}) => ot(t, e, r), t.provideCheckoutData = (e, r = {}) => ct(t, e, r), t.createCustomerAddress = (e, r, o = {}) => O(t, e, r, o), t.updateCustomerAddress = (e, r, o, c = {}) => q(
      t,
      e,
      r,
      o,
      c
    ), t.addToCart = (e, r, o = {}) => b(t, e, r, o), t.getCurrentCart = (e, r, o, c = {}) => at(t, e, r, o, c), t.createClaim = (e, r = {}) => nt(t, e, r), t.forgotPassword = (e, r = {}) => mt(t, e, r), t.restorePassword = (e, r = {}) => gt(t, e, r), t.hasUpdatedPassword = (e, r = {}) => ht(t, e, r), t.login = (e, r = {}) => pt(t, e, r), t.register = (e, r = {}) => lt(t, e, r), t;
  }
};
export {
  St as default
};
//# sourceMappingURL=spryker-api.js.map
